import type {SingleComponentPluginFunction} from '../../types'
import type {ComponentExportStructure} from '@wix/document-services-types'
import {convertCodeNameToConnection} from './constants'

export const unpack: SingleComponentPluginFunction = (component: ComponentExportStructure): void => {
    convertCodeNameToConnection(component)
}
